/** Espelho de AcaoTagsVendaEnum (API.Vendas): o que fazer com as tags dos documentos selecionados. */
export enum AcaoTagsVendaEnum {
    Incluir = 1,
    Remover = 2,
    Substituir = 3,
}
